module.exports = __webpack_public_path__ + "img/bca.6013ff8c.svg";